<template>
  <div class="col-12">
    <div class="card" style="overflow: visible">
      <div class="card-header p-0 position-relative " style="height: 60px;">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('classSubjects.editStatusTitle') }}
            </h6>
          </div>
        </div>
      </div>
      
      <div class="card-body px-0 pb-2 pe-3">
        <LoadingSpinner v-if="loadingInitial" :message="$t('classSubjects.loadingSubject')" class="py-5"/>

        <div v-else-if="!subjectFound" class="alert alert-danger text-center mx-4">
          <i class="fas fa-exclamation-circle me-2"></i>
          {{ $t('classSubjects.subjectNotFound') }}
        </div>

        <div v-else class="p-4">
          <div class="mb-4 text-center">
            <h5 class="text-gradient text-primary mb-2">{{ subjectName }}</h5>
            <p class="text-muted">{{ subjectCode }}</p>
          </div>

          <div class="mb-3">
            <label class="form-label">{{ $t('classSubjects.statusLabel') }}</label>
            <select class="form-select borderless-input" v-model="status">
              <option value="active">{{ $t('classSubjects.active') }}</option>
              <option value="inactive">{{ $t('classSubjects.inactive') }}</option>
            </select>
          </div>

          <div class="d-flex gap-3 mt-4">
            <button 
              type="button" 
              class="btn btn-primary btn-sm flex-grow-1"
              @click="saveChanges"
              :disabled="loading"
            >
              <span v-if="loading">
                <i class="fas fa-spinner fa-spin ms-2"></i>
                {{ $t('classSubjects.saving') }}
              </span>
              <span v-else>
                <i class="fas fa-save ms-2"></i>
                {{ $t('classSubjects.saveChanges') }}
              </span>
            </button>
            <button 
              type="button" 
              class="btn btn-outline-secondary btn-sm flex-grow-1"
              @click="goBack"
            >
              <i class="fas fa-times me-2"></i>
              {{ $t('classSubjects.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const toast = useToast();
const route = useRoute();
const router = useRouter();
const store = useStore();

const classId = route.params.classId;
const subjectId = route.params.subjectId;
const loading = ref(false);
const loadingInitial = ref(true);
const status = ref('active');
const subjectFound = ref(false);

const currentSubject = computed(() => {
  return store.state.classsubjects.classSubjects.find(
    s => (s.subject_id == subjectId || s.id == subjectId)
  );
});

const subjectName = computed(() => currentSubject.value?.subject?.name || currentSubject.value?.name || '');
const subjectCode = computed(() => currentSubject.value?.subject?.code || currentSubject.value?.code || '');

onMounted(async () => {
  try {
    if (!currentSubject.value) {
      await store.dispatch('classsubjects/fetchClassSubjects', { classId });
    }
    
    if (currentSubject.value) {
      status.value = currentSubject.value.status || 'active';
      subjectFound.value = true;
    }
  } catch (error) {
    toast.error(t('classSubjects.fetchErrorEdit'));
  } finally {
    loadingInitial.value = false;
  }
});

const saveChanges = async () => {
  try {
    loading.value = true;
    await store.dispatch('classsubjects/updateClassSubject', {
      classId,
      subjectId,
      status: status.value
    });
    toast.success(t('classSubjects.updateSuccess'));
    goBack();
  } catch (error) {
    toast.error(error.response?.data?.message || t('classSubjects.updateError'));
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.push(`/classes/${classId}/subjects`);
};
</script>
